import { StatusType } from 'common/api/endpoints/companies';
export default StatusType;
